<template>
	<div>
		<div class="main-container">
			<div class="navBarTest">
				<Navbar />
			</div>
			<div class="secondary-title-wrapper col-lg-12" style="margin-bottom:-150px; border-bottom: solid #007cc3">
				<h1 class="h3 my-0 mx-lg-5 secondary-title">{{ $t('talentExpert.mainTitle') }}</h1>
			</div>
			<div class="row box-image-wrapper mx-auto px-lg-4 mw-100" style="display: flex;justify-content: space-around;margin-top: 175px;">
				<div class="description col-lg-6 box-image position-relative text-center wow move-up" style="visibility: visible; display: flex; flex-direction: column;align-items:center;">
					<img class="imgPage border-radius mw-100" style="width:auto;max-height:500px" src="../assets/img/3d/talent-1.jpg">
					
					<p style="white-space: pre-line;" class="text-center my-4">{{ $t('talentExpert.mainText') }}</p>
					<div class="row">
						<div class="col-md-6">
							<img class="imgPage w-100 same-height-img border-radius" src="../assets/img/3d/talent-cover.png" 
							>
						</div>
						<div class="col-md-6">
							<img class="imgPage w-100 same-height-img border-radius" src="../assets/img/3d/talent-2.jpg" 
							>
						</div>
					</div>
				</div>

				<div class="col-lg-5 col-12">
					<ContactForm :boolEmbeded="true" :ctaText="$t('talentExpert.formText')" :serviceWanted="'Talent/Expert'" />
				</div>
			</div>
		</div>
		<div>
			<FooterMain />
		</div>
	</div>
</template>

<script>
	import Navbar from '../components/Navbar.vue'
    import ContactForm from '../components/ContactForm.vue'
	import FooterMain from '../components/FooterMain.vue'

	export default {
		name: 'TalentExpert',
		components: {
			Navbar,
            ContactForm,
			FooterMain
		},
		metaInfo(){
			return {
				title: this.$i18n.t('tabTitle.talentExpert'),
				meta: [
					{ "name": "description", "content":  this.$i18n.t('meta.description.talentExpert') },
					{ "name": "theme-color", "content": "#007BFF;" }
				]
			}
		},
		created(){
			if(typeof window.gtag !== 'undefined'){
				window.gtag('config', process.env.VUE_APP_GTAG_UA, {
						'page_title' : this.$i18n.t('tabTitle.talentExpert'),
						'page_path': this.$i18n.t('links.talentExpert')
				});
				window.gtag('config', process.env.VUE_APP_GTAG_G, {
						'page_title' : this.$i18n.t('tabTitle.talentExpert'),
						'page_path': this.$i18n.t('links.talentExpert')
				});
			}
			if(typeof window.fbq !== 'undefined'){
				window.fbq('track', 'PageView');
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '../assets/scss/variabls.scss';
	@import '../assets/scss/elements/page-equipements.scss';
	
	.same-height-img {
        height: 300px;
        object-fit: cover;
    }
	.border-radius {
		border-radius: 2px;
	}
</style>